export default "__VITE_ASSET__IJWgTbwe__"